import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { StoryDetailsRes } from "../../types/StatusTypes";
import { useAppSelector } from "../../utils/hooks";

export const useStatusDetails = () => {
  const story_id =
    useAppSelector((state) => state.ViewManager.currentStatusId) ?? 0;

  return useQuery<StoryDetailsRes, Error>(
    ["story/get-story", story_id],
    async () => {
      const response = await axiosInstance.post<StoryDetailsRes>(
        "story/get-story",
        {
          story_id,
        }
      );

      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: story_id > 0,
    }
  );
};
